import React from "react";
import Jobcard from './pages/Jobcard/Jobcard.jsx';
import Timeline from "./pages/Timeline/Timeline.jsx";
import Dashboard from "./pages/Dashboard/Dashboard.jsx";
import Master from "./pages/Master/Master.jsx";
import DataIngestion from "./pages/Data Ingestion/DataIngestion.jsx";
import UserManagement from "./pages/User Management/User-Management.jsx";
import NewUsers from "./Component/sub-userMgmt/NewUsers.jsx"; 
import Qc from "./pages/QA/Qc.jsx";
import{
  BrowserRouter as Router ,
  Routes ,
  Route
} from 'react-router-dom';
function App() {
  return (
    <Router>
      <Routes>
        <Route exect path = "/jobcard" element = {<Jobcard />} />
        <Route path = "/timeline" element = {<Timeline />} />
        <Route path = "/" element = {<Dashboard />} />
        <Route path = "/master" element = {<Master />} />
        <Route path = "/data-ingestion" element = {<DataIngestion />} />
        <Route path = "/usermanagement" element = {<UserManagement />} />
        <Route path = "/new-users" element = {<NewUsers />} />
        <Route path = "/qa-qc" element = {<Qc />} />
      </Routes>
    </Router>
  );
}

export default App;
